import { debounce as _debounce } from "lodash"

const debounce = fn =>
  _debounce(fn, 2000, {
    trailing: false,
    leading: true,
  })

export default debounce
